export default __webpack_public_path__ + "static/media/mark-question-icon.f5311c2c.svg";